module.exports = __webpack_public_path__ + "static/media/alert-circle.1c91227d.svg";